import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadGeneralSettingsFailed, loadGeneralSettingsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadGeneralSettings(action) {
  try {
    const url = `${BACKEND_URL}/api/status`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadGeneralSettingsSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadGeneralSettingsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadGeneralSettingsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
